// extracted by mini-css-extract-plugin
export default {"logo":"AppHeader_logo__1kOOE"};